import { ConjunctionType } from '@app/shared/models/contracts/enums/shared-enums';
import { enumToOptions } from '@app/shared/helpers';

export const CONJUNCTION_TYPE_OPTIONS = enumToOptions(ConjunctionType);
